const ColmoMixin = {
  computed: {
    _theme() {
      return this.$theme ? (this.$theme.getRootTheme && this.$theme.getRootTheme()) || this.$theme.getTheme() : ''
    },
    _isColmo() {
      if (!this.$theme) return false
      return this._theme === 'colmo'

      // let tmp = this.$theme.watchTheme({
      //   colmo: true,
      //   default: false
      // })
      // return tmp
    }
  }
}

export default ColmoMixin



// WEBPACK FOOTER //
// ./mixins/colmo.js